import { resolveLoginAppUrl } from '@imobdesk/env'
import { getImobdeskEnvRecord } from '@/lib/imobdesk-env-record'

const DEFAULT_LOGIN_APP_ORIGIN = 'https://login.imobdesk.com.br'

/**
 * URL base do app de login (Vite), ex.: https://login.imobdesk.com.br
 */
export function getLoginAppOrigin(): string {
  const raw = resolveLoginAppUrl(getImobdeskEnvRecord())
  if (!raw) {
    return DEFAULT_LOGIN_APP_ORIGIN
  }
  const candidate = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`
  try {
    return new URL(candidate).origin
  } catch {
    console.error('[admindesk] VITE_LOGIN_APP_URL inválida:', raw)
    return DEFAULT_LOGIN_APP_ORIGIN
  }
}

/**
 * Inicia login global com retorno ao admindesk (handoff).
 * `nextPathWithQuery`: path absoluto permitido, ex. `/admin`, `/contratar/pro?trial=14`
 */
export function buildImobdeskLoginUrlForAdmindesk(nextPathWithQuery: string): string {
  const origin = getLoginAppOrigin()
  if (!origin) return ''
  const u = new URL(`${origin}/`)
  u.searchParams.set('return_app', 'admindesk')
  const next = nextPathWithQuery.startsWith('/')
    ? nextPathWithQuery
    : `/${nextPathWithQuery}`
  u.searchParams.set('next', next)
  return u.toString()
}

export function goToLoginApp(options?: {
  sessionEnded?: 'superseded'
}): void {
  const origin = getLoginAppOrigin()
  const url = new URL(origin)
  url.pathname = '/'
  if (options?.sessionEnded === 'superseded') {
    url.searchParams.set('session_ended', 'superseded')
  } else {
    url.searchParams.set('signed_out', '1')
  }
  window.location.href = url.toString()
}
